import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['trigger', 'dropdown', 'input', 'otherField', 'option']

  disconnect() {
    document.addEventListener('turbolinks:before-cache', this.hideAll());
  }
  
  toggle() {
    this.dropdownTarget.classList.toggle('hide')
    if (!this.dropdownTarget.classList.contains('hide')) {
      this.focusOnOption()
    }
  }
  
  hide() {
    this.dropdownTarget.classList.add('hide')
  }
  
  show() {
    this.dropdownTarget.classList.remove('hide')
    this.focusOnOption()
  }
  
  clickAway(event) {
    const notTrigger = (this.hasTriggerTarget && this.triggerTarget !== event.target)
    const notInput = (this.hasInputTarget && this.inputTarget !== event.target)
    
    if (event.type == 'click' && (notTrigger && notInput)) {
      this.hideAll()
    }
  }
  
  select(event) {
    event.preventDefault();
    const selectedValue = event.target.dataset.value
    const selectedText = event.target.innerHTML
    
    this.inputTarget.value = selectedValue
    this.triggerTarget.innerHTML = selectedText
    this.hide()
    this.inputTarget.focus()
  }
  
  submit() {
    this.element.submit()
  }
  
  enter(event) {
    event.preventDefault();
    if (event.keyCode == 13) {
      const selectedValue = event.target.dataset.value
      const selectedText = event.target.innerHTML
      
      this.inputTarget.value = selectedValue
      this.triggerTarget.innerHTML = selectedText
      this.hide()
      this.inputTarget.focus()
    }
  }
  
  showOtherField() {
    this.otherFieldTarget.classList.remove('hide')
  }
  
  hideOtherField() {
    this.otherFieldTarget.classList.add('hide')
  }
  
  handleFocus(event) {
    event.preventDefault()
    this.dropdownTarget.classList.remove('hide')
  }
  
  handleBlur() {
    this.dropdownTarget.classList.add('hide')
  }
  
  jumpToOptions(event) {
    if (event.key == 'ArrowDown') {
      event.preventDefault()
      this.show()
      this.optionTarget.focus()
    } else if (event.key == 'ArrowUp') {
      event.preventDefault()
      this.show()
      this.optionTargets[this.optionTargets.length - 1].focus()
    }
  }
  
  handleArrowKeys(event) {
    if (event.key == 'ArrowDown') {
      event.preventDefault()
      this.handleArrowDown(event)
    } else if (event.key == 'ArrowUp') {
      event.preventDefault()
      this.handleArrowUp(event)
    }
  }
  
  handleArrowUp(event) {
    let prevIndex = this.optionTargets.indexOf(event.currentTarget) - 1
    if (prevIndex == -1) {
      this.optionTargets[this.optionTargets.length - 1].focus()
    } else {
      this.optionTargets[prevIndex].focus()
    }
  }
  
  handleArrowDown(event) {
    let nextIndex = this.optionTargets.indexOf(event.currentTarget) + 1
    if (nextIndex == this.optionTargets.length) {
      this.optionTargets[0].focus()
    } else {
      this.optionTargets[nextIndex].focus()
    }
  }
  
  hideAll() {
    this.dropdownTargets.forEach((target) => { 
      if (!target.classList.contains('hide')) {
        target.classList.add('hide')
      }
    })
  }
  
  hideEvery(event) {
    let notTrigger = (this.hasTriggerTarget && this.triggerTarget !== event.target)
    let notInput = (this.hasInputTarget && this.inputTarget !== event.target)
    
    if (event.type == 'click' && (notTrigger && notInput)) {
      document.querySelectorAll('.pop').forEach((element) => {
        element.classList.contains('hide') ? true : element.classList.add('hide')
      })
    }
  }
  
  focusOnOption() {
    if (this.hasOptionTarget && this.optionTarget.dataset.focusOnOption == 'true') {
      this.optionTarget.focus()
    } else {
      return false
    }
  }
}